<lib-modal
  [closeLabel]="'general.close' | translate"
  [visible]="visible()"
  [title]="'modules.embedDialog.title' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="
    selectedCount() > 0
      ? ('modules.embedDialog.addN' | translate: { count: selectedCount() })
      : ('modules.embedDialog.add' | translate)
  "
  [cancelText]="'modules.embedDialog.cancel' | translate"
  [disabled]="!canApply()"
  (save)="onApply()"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #embedContent>
  <div class="med">
    <p class="med__subtitle" data-testid="med-subtitle">
      {{ 'modules.embedDialog.subtitle' | translate: { count: selectedCount() } }}
    </p>

    <div class="med__search">
      <mat-icon class="med__search-icon" aria-hidden="true">search</mat-icon>
      <input
        class="med__search-input"
        data-testid="med-search"
        [value]="searchTerm()"
        [placeholder]="'modules.embedDialog.searchPlaceholder' | translate"
        [attr.aria-label]="'modules.embedDialog.searchPlaceholder' | translate"
        (input)="onSearch($event)"
      />
    </div>

    <div class="med__filters" role="group" [attr.aria-label]="'modules.embedDialog.filterAria' | translate">
      @for (status of statusOptions; track status) {
        <button
          type="button"
          class="med__pill"
          [class.med__pill--on]="statusFilter() === status"
          [attr.data-testid]="'med-status-' + status"
          [attr.aria-pressed]="statusFilter() === status"
          (click)="statusFilter.set(status)"
        >
          {{ (status === 'ALL' ? 'modules.embedDialog.statusAll' : 'modules.status.' + status) | translate }}
        </button>
      }
      <span class="med__divider" aria-hidden="true"></span>
      <select
        class="med__author"
        [class.med__author--set]="authorFilter() !== ''"
        data-testid="med-author"
        [attr.aria-label]="'modules.embedDialog.authorAria' | translate"
        (change)="onAuthorChange($event)"
      >
        <option value="" [selected]="authorFilter() === ''">{{ 'modules.embedDialog.authorAll' | translate }}</option>
        @for (author of authorOptions(); track author.id) {
          <option [value]="author.id" [selected]="authorFilter() === author.id">{{ author.name }}</option>
        }
      </select>
    </div>

    @if (loading()) {
      <div class="med__loading">
        <mat-spinner diameter="28" />
      </div>
    } @else if (error()) {
      <p class="med__error" role="alert">{{ 'modules.embedDialog.loadError' | translate }}</p>
    } @else if (filtered().length === 0) {
      <p class="med__empty" data-testid="med-empty">{{ 'modules.embedDialog.empty' | translate }}</p>
    } @else {
      <ul class="med__list">
        @for (module of filtered(); track module.id) {
          <li>
            <button
              type="button"
              class="med__item"
              [class.med__item--on]="isSelected(module.id)"
              role="checkbox"
              [attr.aria-checked]="isSelected(module.id)"
              [attr.data-testid]="'med-row-' + module.id"
              (click)="toggle(module.id)"
            >
              <span class="med__check" aria-hidden="true">
                @if (isSelected(module.id)) {
                  <mat-icon>check</mat-icon>
                }
              </span>
              <code class="med__id">{{ module.key }}</code>
              <span class="med__text">
                <span class="med__name">{{ module.name }}</span>
                @if (module.description) {
                  <span class="med__desc">{{ module.description }}</span>
                }
              </span>
              <span class="med__steps">
                {{ 'modules.embedDialog.steps' | translate: { count: module.stepCount ?? 0 } }}
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
